<template>
  <div :class="{ [$style.basket]: true, [$style['basket--disabled']]: disabled }">
    <div v-show="!appShopModus" :class="$style['basket-info']">
      <div :class="[$style.row, $style.icon]">
        <IconSelect icon="basketmobile" height="30" width="30" :class="$style['basket-icon']" />
        <v-progress-circular
          v-show="pending"
          :class="$style.spinner"
          size="15"
          width="2"
          :indeterminate="pending"
          color="white"
        />
        <span v-if="amount > 0" :class="$style.amount">{{ amount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'

import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'
import aimeosGetters from '@/js/plugins/store/modules/aimeos/getter-types'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'MobileMiniBasket',
  components: {
    IconSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(STOREMODULES.AIMEOS, {
      amount: aimeosGetters.BASKET_COUNT,
      price: aimeosGetters.BASKET_PRICE,
      currency: aimeosGetters.BASKET_CURRENCYID,
      pending: `BASKET_${REQUEST_STATE.STATE_PENDING}`,
    }),
    ...mapGetters(STOREMODULES.APP, {
      appShopModus: APP_GETTER.SHOPMODUS,
    }),
    priceFormatted() {
      return this.price ? this.$n(this.price, { key: 'currency', currency: this.currency }) : '-'
    },
  },
}
</script>

<style lang="scss" module>
.basket {
  position: relative;

  display: flex;
  align-items: center;
  height: 50px;

  cursor: pointer;

  user-select: none;

  .spinner {
    position: absolute;
    top: 4px;
    left: 8px;

    color: var(--black) !important;
  }
}

.basket--disabled {
  cursor: default;
}

.amount {
  position: absolute;
  top: 7px;
  right: 5px;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;

  color: var(--white);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-xs);
  line-height: 0;

  background-color: var(--black);
  border-radius: 50%;
}

.row {
  position: relative;
}

.basket-icon {
  width: 55px !important;
}

.icon {
  position: relative;
}
</style>
